import DataTable, { defaultThemes } from 'react-data-table-component';

export default function UsuariosTabela({ colunas, itens }: { colunas: any, itens: any[] }) {
    const customStyles = {
        headCells: {
            style: {
                color: '#5E6397',
                fontFamily: 'Assistant',
                fontSize: '16px',
                paddingTop: '15px',
                paddingBottom: '15px',
                ':last-child': {
                    maxWidth: '150px',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                ':first-child': {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default
                },
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default
            },
        },
        cells: {
            style: {
                color: '#A3A3A3',
                fontFamily: 'Merriweather Sans',
                fontSize: '1.000em',
                paddingTop: '15px',
                paddingBottom: '15px',
                ':last-child': {
                    maxWidth: '150px',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
                ':nth-child(4n)': {
                    minWidth: '83px'
                },
                ':first-child': {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                    color: '#525252',
                },
                borderBottomStyle: 'solid',
                borderBottomWidth: '1px',
                borderBottomColor: defaultThemes.default.divider.default,
            },
        }
    };

    return <>
        {
            itens.length > 0 ? <DataTable columns={colunas} data={itens} customStyles={customStyles} dense /> : <h2 className="mt-5">Não possuem eventos para serem exibidos</h2>
        }
    </>
}